// @ts-check
import * as React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ArrowLink from "../ArrowLink/arrow-link";

const TitleLinkTop = ({ ClassName, Title, ViewMoreLink, TextColorClass }) => {
    const baseClass = "title-link-top";
    const componentClasses = classNames(baseClass, "content-module-header", ClassName);
    const titleClasses = classNames(`${baseClass}__title`, {
        [`${TextColorClass}--text`]: !!TextColorClass
    });

    const linkClasses = classNames(`${baseClass}__link`, {
        [`${TextColorClass}--text`]: !!TextColorClass
    });

    const headerTitle = Title && <h2 className={titleClasses} dangerouslySetInnerHTML={{ __html: Title }} />;
    const headerLink = ViewMoreLink && <ArrowLink ClassName={linkClasses} CtaLink={ViewMoreLink} />;

    return (
        <div className={componentClasses}>
            {headerTitle}
            {headerLink}
        </div>
    );
};

TitleLinkTop.propTypes = {
    ClassName: PropTypes.string,
    Title: PropTypes.string,
    ViewMoreLink: PropTypes.string,
    TextColorClass: PropTypes.string
};

export default TitleLinkTop;
